module.exports = __webpack_public_path__ + "static/media/cart-icon.5446b6cb.svg";